import React from 'react'
import Head from '../components/Head'
import Header from '../components/Header'
import Footer from '../components/footer'

export default class extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Head title="PlayVS | Privacy Policy" />

        <Header className="header--light" />

        <section>
          <div className="container">
            <div className="row--thinner">
              <div className="section__head">
                <h1>Privacy Policy</h1>
                <p>PlayVS takes your privacy very seriously. <br />
                  This privacy policy was last modified on October 10, 2018.</p>

              </div>
              <p>
                At Play Versus, Inc (“<strong>PlayVS</strong>,” “<strong>we</strong>,” “<strong>us</strong>,”
                “<strong>our</strong>”), we know you care about how your personal information is used and
                shared, and we take protecting the privacy of our users very seriously. This Privacy Policy
                explains how your personal information is collected, used and disclosed by Play Versus when
                you visit or use our website, <a href="http://www.playvs.com">www.playvs.com</a> (our “<strong
                >
                  Website
                </strong>”), and our related software and online or mobile services provided on or in
                connection with our Website (collectively, our “<strong>Service</strong>”). By accessing or
                using our Service, you signify that you have read, understood and agree to our collection,
                storage, use and disclosure of your personal information as described in this Privacy Policy
                and our <a href="/terms">Terms of Use</a>. Please take a moment to familiarize yourself with our privacy
                practices and let us know if you have any questions.
              </p>
              <p>
                All capitalized terms that are not defined in this Privacy Policy shall have the meaning
                given to them in the <a href="/terms">Terms of Use</a>.{' '}
              </p>
              <p>
                <strong>A note about Student Data</strong>: PlayVS is the official high school esports
                league, used by schools, school districts and athletic associations (collectively referred
                to as “<strong>Schools</strong>”) to offer competitive esports activities to students (“<strong
                >
                  Students
                </strong>”). We take our commitment to student privacy very seriously. Please see Section 6
                to understand the principles that guide our collection, use and disclosure of Student Data.
              </p>
              <p>Click on the links below to jump to each section: </p>
              <ol>
                <li>
                  <a href="#personal">PERSONAL INFORMATION WE COLLECT</a>
                </li>
                <li>
                  <a href="#sharing">SHARING OF YOUR INFORMATION</a>
                </li>
                <li>
                  <a href="#third-party">THIRD PARTY TRACKING AND ONLINE ADVERTISING</a>
                </li>
                <li>
                  <a href="#storage">HOW WE STORE AND PROTECT OUR INFORMATION</a>
                </li>
                <li>
                  <a href="#rights">YOUR DATA RIGHTS AND CHOICES</a>
                </li>
                <li>
                  <a href="#protect">HOW DOES PLAY VERSUS PROTECT STUDENT DATA AND COMPLY WITH LAWS?</a>
                </li>
                <li>
                  <a href="#links">LINKS TO OTHER WEB SITES AND SERVICES</a>
                </li>
                <li>
                  <a href="#california">YOUR CALIFORNIA PRIVACY RIGHTS</a>
                </li>
                <li>
                  <a href="#contact">HOW TO CONTACT US</a>
                </li>
                <li>
                  <a href="#changes">CHANGES TO OUR PRIVACY POLICY</a>
                </li>
              </ol>
              <h4>
                <a name="personal" />1. PERSONAL INFORMATION WE COLLECT
              </h4>
              <p>
                <strong>
                  Information you provide to us and information we receive about you from others
                </strong>
              </p>
              <p>
                We may collect personal information when you when you create a registered user account, sign
                up for our mailing list, purchase or register a product, or otherwise communicate with us.
                The personal information we collect during registration may depend on your account type and
                whether you are a School representative, parent or coach, but could include: name, phone
                number, email address, mailing address, school (name, city, state) and payment information.
                We may also collect such information when you contact us in person (for example, at camps,
                competitions, conferences, workshops, seminars and other events), via telephone, facsimile
                or email.{' '}
              </p>
              <p>In addition, we collect the following types of information: </p>
              <p>
                <strong>Information about Schools:</strong> We ask for certain information when a School
                representative registers a School with PlayVS, or if the representative corresponds with us
                online, including a name, school name, school district, school email address, role at
                school, phone number, and relevant IT and equipment information required for students to
                participate on campus. School representatives and coaches may also provide information about
                students, such as a team roster. We may also collect information provided by a School if the
                School sends us a message, posts content to our website or through our Service, or responds
                to emails or surveys. Once a School begins using the PlayVS Service, we will collect content
                and information provided by the School through the School’s use of the Service and we will
                keep records of activities related to the Service.{' '}
              </p>
              <p>
                <strong>Information about Students: </strong>We collect information about student athletes
                from the School or from the student directly, including name, phone number, email address,
                mailing address, school (name, city, state), and may collect additional information
                associated with the student’s Athlete Profile, including the athlete player name,
                parent/guardian information (name, relation, e-mail and phone), age and graduation year,
                photograph, jersey number, and esports position. Personal information collected from or
                about students, along with other information associated with that personal information, is
                referred to as “<strong>Student Data</strong>.” Please refer to Section 6 to learn more
                about how we use and protect Student Data.{' '}
              </p>
              <p>
                <strong>Data collected through the use of the Service:</strong> We collect information about
                how you use the Service, your actions on the Service, and content you post to the Service (“<strong
                >
                  User Content
                </strong>”), as well as information about a player or team record, for example, gameplay
                statistics, personal or team awards and highlights featuring the team or athlete.{' '}
              </p>
              <p>
                <strong>Information we receive from third parties:</strong> We may receive personal
                information about you from third parties and combine that with the information we collect
                through the Service. For example, we may receive your contact information from your school
                or Coach to register you for a school team. We receive information about your activities on
                third party games you access through the Service.{' '}
              </p>
              <p>
                We use this information to operate, maintain, and provide the features and functionality of
                the Service, as well as to communicate directly with you, such as to send you email messages
                and push notifications, and permit you to communicate with others on the Service or invite
                others to join the Service. We may also send you Service-related emails or messages (e.g.,
                account verification, change or updates to features of the Service, technical and security
                notices). For more information about your communication preferences, see “Your Data Rights
                and Choices” below.{' '}
              </p>
              <p>
                <strong>Usage and Device Information</strong>
              </p>
              <p>
                To provide a personalized and high-quality experience for our users, we may use various
                technologies that automatically record certain technical information from your browser or
                device when you visit our website, read our emails, use our Service or otherwise engage with
                us. This information is typically collected through a variety of tracking technologies,
                including cookies, web beacons, file information and similar technology (collectively, “<strong
                >
                  tracking technologies
                </strong>”). These tracking technologies cookies collect information about how you use the
                Service (e.g., the pages you view, the links you click, emails you open, and other actions
                you take on the Service), information about your browser and online usage patterns (e.g.,
                Internet Protocol (“IP”) address, browser type, browser language, referring / exit pages and
                URLs, pages viewed, whether you opened an email , links clicked), and information about the
                device(s) you use to access the Service (e.g., mobile device identifier, mobile carrier,
                device type, model and manufacturer, mobile device operating system brand and model, and
                whether you access the Service from multiple devices). We may be able to determine your
                approximate location by analyzing other information, like an IP address to associate a user
                with their School. We may also collect analytics data, or use third-party analytics tools
                such as Google Analytics to help us measure traffic and usage trends for the Service. You
                can learn more about Google’s practices at{' '}
                <a href="http://www.google.com/policies/privacy/partners">
                  http://www.google.com/policies/privacy/partners
                </a>, and view its currently available opt-out options at{' '}
                <a href="https://tools.google.com/dlpage/gaoptout">
                  https://tools.google.com/dlpage/gaoptout
                </a>. Although we do our best to honor the privacy preferences of our visitors, we are not
                able to respond to Do Not Track signals from your browser at this time.{' '}
              </p>
              <p>
                We use or may use the data collected through tracking technologies to secure the Service,
                improve the Service, to save you time, to provide better technical support, and to track
                website usage. For example, tracking technologies help us to: (a) remember information so
                that a user will not have to re-enter it during subsequent visits; (b) provide custom,
                personalized content and information; (c) to identify you across multiple devices; (d) to
                provide and monitor the effectiveness of our Service; (e) monitor aggregate metrics such as
                total number of visitors, traffic, and usage on our website and our Service; (f) diagnose or
                fix technology problems; (g) help users efficiently access information after signing in, and
                (h) otherwise to plan for and enhance our Service.{' '}
              </p>
              <p>
                If you would prefer not to accept cookies, most browsers will allow you to: (i) change your
                browser settings to notify you when you receive a cookie, which lets you choose whether or
                not to accept it; (ii) disable existing cookies; or (iii) set your browser to automatically
                reject cookies. Please note that doing so may negatively impact your experience using the
                Service, as some features and services on our Service may not work properly. Depending on
                your mobile device and operating system, you may not be able to delete or block all cookies.
                You may also set your email options to prevent the automatic downloading of images that may
                contain technologies that would allow us to know whether you have accessed our email and
                performed certain functions with it.{' '}
              </p>
              <p>
                We and our third-party partners may also use cookies and tracking technologies for
                advertising purposes. For more information about tracking technologies, please see
                “Third-party tracking and online advertising” below.
              </p>
              <h4>
                <a name="sharing" />2. SHARING OF YOUR INFORMATION{' '}
              </h4>
              <p>
                PlayVS takes great care to protect the information you provide us. We do not rent or sell
                personal information that we collect from users with third parties for marketing purposes.
              </p>
              <p> </p>
              <p>
                PlayVS will disclose your personal information when you post content which is visible to
                others on the Service, when you consent or instruct us to share your information with third
                parties, or when we have a legitimate business or legal need to share your information. We
                may also disclose anonymous or aggregate information that does not reasonably identify you
                as an individual. For example, your information may be shared with:{' '}
              </p>
              <p>
                <strong>
                  The public (when Student Data contained in Competition Data is visible to others on the
                  Service by default).{' '}
                </strong>Like any high school sports league, some information about student athletes and
                competition results is posted on the Service and may be visible to other users, website
                visitors and the public (“<strong>Competition Data</strong>”). Competition Data includes
                certain personal information from the student’s Athlete Profile, including athlete player
                name, full name, graduation year, school (name, city, state), photograph, jersey number, and
                esports position, as well as athlete player statistics and gameplay highlights, which will
                be available publicly on the Service by default when you participate in the Service. Email
                addresses, phone number, parent or guardian information (name, relation, email and phone),
                payment details, and birth date are not Competition Data and are not available to the
                general public.
              </p>
              <p>
                <strong>Other members of the Service. </strong>We disclose personal information between and
                among other users of the Service associated with the School, such as coaches, team
                administrators and school representatives. These users will be able to view your entire
                Athlete Profile, including email and home address, phone number and parent/guardian
                information.{' '}
              </p>
              <p>
                <strong>Third parties game providers authorized by the School or Coach. </strong> Play
                Versus facilitates gameplay through third party game providers. When a School elects to
                participate in a game provided by a third party game provider, we share some information
                about the School and its student athletes (including player name, school, esports jersey
                number and position) with that third party game provider to help populate your user profile
                and track team gameplay on the third party service. These third party game providers use
                your information according to their own privacy policy and practices, which may differ from
                the practices described in this Play Versus privacy policy. Schools and team coaches should
                review the privacy policy of any third party game provider or service to understand their
                privacy practices before you participate in any third party game through the Service.{' '}
              </p>
              <p>
                <strong>Third parties with your consent or according to your instructions. </strong>You may
                provide consent or authorization to share your personal information with third party
                applications or services in several ways, depending on the functionality available now and
                in the future through the Play Versus Service. Please note that these third parties are not
                governed by PlayVS or the terms of this Privacy Policy. We recommend you review the privacy
                policy of any third party application or service before authorizing access to your PlayVS
                account information. For example, you may authorize Play Versus to share your information
                with:{' '}
              </p>
              <ul>
                <li>
                  Special programs you participate in. If you participate in special programs where PlayVS
                  partners with third parties, PlayVS may share data collected from or about you with its
                  third party partners to facilitate the program or services being offered.{' '}
                </li>
                <li>
                  Others with your consent. In some instances, you may be able to grant us permission to
                  share your information third-party partners, recruiters, not-for-profit organizations, and
                  other entities that are not affiliated with PlayVS. In these cases, we will only provide
                  to these third parties the information you have authorized or asked us to share to these
                  third parties. You may also choose to share content with others by email, or by posting
                  PlayVS content to social media sites such as Facebook or Twitter. These third parties may
                  use your information as described in their own privacy policies. To control the
                  information that you share, you have the option of modifying your PlayVS or social network
                  settings or disconnecting your social network account from your PlayVS account.
                </li>
              </ul>
              <p>We may also share information for the following business purposes: </p>
              <ul>
                <li>
                  Third-party vendors and other service providers that perform services on our behalf, as
                  needed to carry out their work for us, which may include providing mailing services,
                  providing payment or accounting services, web hosting, or providing analytic services.{' '}
                </li>
                <li>
                  Other parties in connection with a company transaction, such as a merger, sale of company
                  assets or shares, reorganization, financing, change of control or acquisition of all or a
                  portion of our business by another company or third party, or in the event of a bankruptcy
                  or related or similar proceedings. If we sell, divest or transfer our business, we will
                  require the new owner to continue to honor the terms provided in this Privacy Policy or we
                  will provide the School with notice and an opportunity to opt-out of the transfer of
                  Student Data by deleting the Student Data before the transfer occurs.{' '}
                </li>
                <li>
                  Third parties as required by law or subpoena or if we reasonably believe that such action
                  is necessary to (a) comply with the law and the reasonable requests of law enforcement;
                  (b) to enforce our <a href="/terms">Terms of Use</a> or to protect the security or integrity of our
                  Service; and/or (c) to exercise or protect the rights, property, or personal safety of
                  Play Versus, our users, visitors, or others.
                </li>
              </ul>
              <p>
                We may also share information with others in an aggregated or otherwise anonymized form that
                does not reasonably identify you directly as an individual. For example, we may use and
                share aggregate or anonymized data to study and improve our Service, user functionality and
                product offerings.
              </p>
              <h4>
                <a name="third-party" />3. THIRD PARTY TRACKING AND ONLINE ADVERTISING
              </h4>
              <p>
                Play Versus does not display any targeted advertising on the Service, though we may display
                contextual advertising or sponsored content.{' '}
              </p>
              <p>
                We participate in interest-based advertising and use third party advertising partners to
                collect information from visitors to the Service for the purpose of displaying
                interest-based advertisements on other websites, apps or services, social networks, or on
                other devices you may use. Typically, though not always, these third party ad networks use
                cookies and tracking technologies to recognize your browser or device and to collect
                information about your visit to our Service to provide you customized content, advertising
                and commercial messages which may be more relevant to your interests, as well as to provide
                advertising-related services such as reporting, attribution, analytics and market research.{' '}
              </p>
              <p>
                Please note that we use our best efforts and take multiple steps to avoid the use of Student
                Data for targeted advertising purposes. For example, we take steps to inhibit these third
                party advertising networks from collecting information for targeted advertising purposes
                when a student athlete logs into the Service.{' '}
              </p>
              <p>
                To learn about interest-based advertising and how you may be able to opt-out of some of this
                advertising, you may wish to visit the Network Advertising Initiative’s online resources, at{' '}
                <a href="http://www.networkadvertising.org/choices">
                  http://www.networkadvertising.org/choices
                </a>, and/or the DAA’s resources at{' '}
                <a href="http://www.aboutads.info/choices">www.aboutads.info/choices</a>. You may also be
                able to limit interest-based advertising through the settings on your mobile device by
                selecting “limit ad tracking” (iOS) or “opt-out of interest based ads” (Android). You may
                also be able to opt-out of some – but not all – interest-based ads served by mobile ad
                networks by visiting{' '}
                <a href="http://youradchoices.com/appchoices">http://youradchoices.com/appchoices</a> and
                downloading the mobile AppChoices app.{' '}
              </p>
              <p>
                Please note that opting-out of receiving interest-based advertising through the NAI’s and
                DAA’s online resources will only opt-out a user from receiving interest-based ads on that
                specific browser or device, but the user may still receive interest-based ads on his or her
                other devices. You must perform the opt-out on each browser or device you use.
              </p>
              <h4>
                <a name="storage" />4. HOW WE STORE AND PROTECT OUR INFORMATION{' '}
              </h4>
              <p>
                <strong>Storage and processing:</strong> Your information collected through our Service may
                be stored and processed in the United States or any other country in which Play Versus or
                its affiliates or service providers maintain facilities. If you are located in the European
                Union or other regions with laws governing data collection and use that may differ from U.S.
                law, please note that we may transfer information, including personal information, to a
                country and jurisdiction that does not have the same data protection laws as your
                jurisdiction.{' '}
              </p>
              <p>
                <strong>Keeping information safe:</strong> We care about the security of your information
                and employ physical, administrative, and technological safeguards designed to preserve the
                integrity and security of all information collected and maintained by our Service. Access to
                information is limited (through user/password credentials and two factor authentication) to
                those employees who require it to perform their job functions. We use industry-standard
                Secure Socket Layer (SSL) encryption technology to safeguard the account registration
                process and sign-up information. Other security safeguards include but are not limited to
                data encryption, firewalls, and physical access controls to building and files. However, no
                security system is impenetrable and we cannot guarantee the security of our systems 100%. In
                the event that any information under our control is compromised as a result of a breach of
                security, we will take reasonable steps to investigate the situation and, where appropriate,
                notify those individuals whose information may have been compromised and take other steps,
                in accordance with any applicable laws and regulations.
              </p>
              <h4>
                <a name="rights" />5. YOUR DATA RIGHTS AND CHOICES{' '}
              </h4>
              <p>
                <strong>Account information and settings: </strong>You may update your account information
                by editing your profile or signing into the account settings.{' '}
              </p>
              <p>
                <strong>Control email communications: </strong>You can opt-out of receiving promotional
                emails from us by clicking the “unsubscribe” feature at the bottom of each email.
                Unfortunately, you cannot unsubscribe from Service-related messaging.{' '}
              </p>
              <p>
                <strong>Modifying or deleting your information:</strong> If you have any questions about
                reviewing, modifying, or deleting your information, or if you want to remove your name or
                comments from our website or publicly displayed content, you can contact us directly at{' '}
                <a href="mailto:privacy@playvs.com">privacy@playvs.com</a>. We may not be able to modify or
                delete your information in all circumstances.{' '}
              </p>
              <p>
                If you have any questions or requests about your account information, contact us directly at{' '}
                <a href="mailto:privacy@playvs.com">privacy@playvs.com</a>.{' '}
              </p>
              <h4>
                <a name="protect" />6. HOW DOES PLAY VERSUS PROTECT STUDENT DATA AND COMPLY WITH LAWS?
              </h4>
              <p>
                Through the course of providing the Service, Play Versus collects information about student
                athletes who use the Service to compete in esports. Personal information collected from or
                about students, along with other information associated with that personal information, is “<strong
                >
                  Student Data
                </strong>.” The Student Data we collect can include name, phone number, email address,
                mailing address, school (name, city, state), and may collect additional information
                associated with the Student athlete profile, including the athlete player name,
                parent/guardian information (name, relation, e-mail and phone), age and graduation year,
                photograph, jersey number, and esports position. Please note that students have the ability
                to save or maintain control over information associated with the student’s account by
                establishing or converting the account to a personal account on the Service or by
                transferring, sharing, or linking such information to a personal account. Information
                associated with a student’s personal account will not be considered “Student Data.”
              </p>
              <p>
                This Section describes our practices with regard to Student Data. Please note that third
                party game providers that Schools may engage with through the Service may have practices and
                policies that differ from those described herein. Student Data we disclose to the game
                provider, as well as any other personal information the game provider collects from the
                School or its students directly, will be governed by the game provider’s own privacy policy
                and the terms of any other agreement between the game provider and the School. Please read
                the Privacy Policy of any third party game provider to understand their privacy practices
                before you participate in a third party game.
              </p>
              <p>
                <strong>Student Data privacy principles. </strong>We are committed to the following
                principles to protect Student Data:{' '}
              </p>
              <ul>
                <li>
                  We collect, maintain, use and share Student Data only to provide and support the Service
                  as described in our Privacy Policy, to maintain, develop, support or improve our websites,
                  services and applications, and as otherwise permitted by our agreements or with the
                  consent of the parent, guardian, student or School.{' '}
                </li>
                <li>
                  We do not use or disclose Student Data for targeted advertising purposes. While we do
                  permit third party advertising partners to operate on our Service for the purpose of
                  retargeting, analytics and attribution services, we disable third party ad networks when a
                  student users logs into an account on the Service.
                </li>
                <li>
                  We do not build a personal profile of a student other than in furtherance of the School’s
                  use of the Service (for example, athlete profiles and player history are created and
                  displayed as part of the esports competition statistics and history), or as authorized by
                  a student or parent.
                </li>
                <li>
                  We maintain a comprehensive data security program designed to protect the types of Student
                  Data maintained by the Service.{' '}
                </li>
                <li>
                  We will clearly and transparently disclose our data policies and practices to our users.{' '}
                </li>
                <li>
                  We will never sell Student Data unless the sale is part of a corporate transaction, such
                  as a merger, acquisition, bankruptcy, or other sale of assets, in which case we will
                  require the new owner to continue to honor the terms provided in this Privacy Policy or we
                  will provide the School with notice and an opportunity to opt-out of the transfer of
                  Student Data by deleting the Student Data before the transfer occurs.{' '}
                </li>
                <li>
                  We will not make any material changes to our Privacy Policy or contractual agreements that
                  relate to the collection or use of Student Data without first giving notice to the School
                  and providing a choice before the Student Data are used in a materially different manner
                  than was disclosed when the information was collected.
                </li>
              </ul>
              <p>
                <strong>How we use and disclose Student Data. </strong>We use and disclose Student Data as
                described in our Privacy Policy under the section “Sharing of Your Information.”{' '}
              </p>
              <p>
                <strong> </strong>
              </p>
              <p>
                <strong>
                  PLEASE NOTE: Competition Data, which may contain Student Data, is disclosed to the public
                  by default.{' '}
                </strong>Like any high school sports league, some information about student athletes and
                competition results is posted on the Service and may be visible to other users, website
                visitors and others (“<strong>Competition Data</strong>”). Competition Data includes certain
                personal information provided by the student in the athlete profile, including: student
                athlete player name, full name, graduation year, school (name, city, state), photograph,
                jersey number, and esports position, as well as athlete player statistics and gameplay
                highlights. Email addresses, phone number, parent or guardian information (name, relation,
                email and phone), payment details, and birth date are not Competition Data and are not
                available to the general public.{' '}
              </p>
              <p>
                Many Schools consider the type of personal information contained in Competition Data to be
                to be “<strong>Directory Data</strong>” under FERPA. If you are a School or Association,
                please confirm that Competition Data related to your School and student athletes may be
                displayed publicly through the Service in accordance with your School’s definition of
                Directory Data and/or that you otherwise have a parent’s or guardian’s consent to display
                such information publicly. If you do not wish to have a student’s personal information
                displayed in Competition Data, please instruct your student athletes to select a player name
                which does not relate to or identify the real name of the student and to leave other data
                fields in the athlete profile blank.{' '}
              </p>
              <p>
                <strong>How we retain and delete Student Data:</strong> We do not knowingly retain Student
                Data beyond the time period required to support the School’s purpose, unless authorized by a
                School, student or parent, though we retain Competition Data and gameplay statistics,
                competition highlights and history indefinitely as part of the official record of the
                esports competition.{' '}
              </p>
              <p>
                We do not delete or de-identify any Student Data from a student athlete account associated
                with an active School contract except at the direction of the School, student or parent. The
                School is responsible for maintaining current student athlete rosters and identifying
                student athlete accounts which the School no longer needs to retain. Unless otherwise
                directed by a School, student or parent, we will delete or de-identify personal information
                contained in student accounts after the termination of our agreement with the School, in
                accordance with the terms of any applicable written agreement with the School, written
                requests from authorized School administrators, and our standard data retention schedule.{' '}
              </p>
              <p>
                Schools and/or students (or their Parents) can request account deletion at any time by
                contacting Play Versus at <a href="mailto:privacy@playvs.com">privacy@playvs.com</a>. We may
                not be able to immediately or completely delete all data in all instances, such as
                information retained in technical support records, customer service records, backups, and
                other similar business records. We will not be required to delete any information which has
                been de-identified or disassociated with personal identifiers such that the remaining
                information cannot reasonably be used to identify a particular individual, nor will we be
                required to delete student information that has been transferred to a personal account
                except at the direction of the student or parent. Please note that we may not be able to
                delete Competition Data but we may be able to anonymize certain Competition Data upon
                request.{' '}
              </p>
              <p>
                <strong>Compliance with laws: </strong>We consider Student Data to be confidential and do
                not use such data for any purpose other than to provide the Services, in accordance with
                contractual agreements with the National Federation of State High School Associations and
                its affiliate entities (NFHS) and the School’s State Association. Play Versus does not own
                or control Student Data, which belongs to the student and/or the School or association that
                contracts with Play Versus to provide the Service to the student.{' '}
              </p>
              <p>
                As specified in our agreements with Schools and Associations, the PlayVS Service is designed
                to provide protections for Student Data as required by applicable privacy laws. For example:{' '}
              </p>
              <ul>
                <li>
                  <strong>The Family Educational Rights and Privacy Act (FERPA).</strong> This Privacy
                  Policy and our Service are designed to meet our responsibilities to protect personal
                  information from the students' educational records under FERPA. We agree to work with each
                  school to jointly ensure compliance with the FERPA regulations.
                </li>
                <li>
                  <strong>Children’s Online Privacy Protection Act (COPPA). </strong>PlayVS is not directed
                  to children under 13 and does not knowingly collect any information from children under
                  the age of 13. A School may not permit a child under 13 to register for the PlayVS Service
                  to compete on the School’s esports team, unless the School represents that it has the
                  authority to provide all necessary consents for PlayVS to collect and use such student’s
                  personal information in the manner contemplated by this Privacy Policy, as permitted by
                  COPPA. Please contact us at <a href="mailto:privacy@playvs.com">privacy@playvs.com</a> if
                  you believe we have inadvertently collected personal information of a child under 13
                  without proper consent so that we may delete such data as soon as possible.{' '}
                </li>
                <li>
                  <strong>Students Online Personal Information Protection Act ("SOPIPA").</strong> This
                  Privacy Policy and our Service are designed to comply with SOPIPA. We do not use Student
                  Data for targeted advertising purposes. We do not use collected information to amass a
                  profile of a K-12 student except in furtherance of providing the features and
                  functionality of the Service. We never sell Student Data unless the sale is part of a
                  corporate transaction, such as a merger, acquisition, bankruptcy, or other sale of assets,
                  in which case we make efforts to ensure the successor entity honors the privacy
                  commitments made in this policy and/or we will notify the School and provide an
                  opportunity to opt-out by deleting student accounts before the data transfer occurs. We
                  will not sell Student Data to third parties other than in the context of a business
                  transaction.
                </li>
                <li>
                  <strong>California Assembly Bill 1584 ("AB 1584").</strong> This Privacy Policy and our
                  Service are designed to comply with AB 1584. Pupil records obtained by Play Versus from a
                  local educational agency ("LEA") continue to be the property of and under the control of
                  the LEA. Parents, legal guardians, or eligible pupils may review personally identifiable
                  information in the pupil's records and correct erroneous information by contacting their
                  LEA directly. In the event of an unauthorized disclosure of a pupil's records, Play Versus
                  will notify the LEA and will provide the LEA with information to be shared with the
                  affected parent(s), legal guardians(s) or eligible pupil(s). Pupil records will be deleted
                  and/or de-identified in accordance with our agreements with each School and as described
                  in this Privacy Policy.
                </li>
              </ul>
              <p>
                If you have any questions about our practices with regard to Student Data, please contact us
                at <a href="mailto:privacy@playvs.com">privacy@playvs.com</a>.
              </p>
              <h4>
                <a name="links" />7. LINKS TO OTHER WEB SITES AND SERVICES
              </h4>
              <p>
                The Service may contain links to and from third party websites of our business partners
                (such as gaming providers), advertisers, social media sites and other services. If you
                follow a link to any of these websites, please note that these websites have their own
                privacy policies and we do not accept any responsibility or liability for their policies or
                content. We strongly recommend that you read their privacy policies and terms and conditions
                of use to understand how they collect, use, and share information.{' '}
              </p>
              <h4>
                <a name="california" />8. YOUR CALIFORNIA PRIVACY RIGHTS
              </h4>
              <p>
                If you are a California resident, California Civil Code Section 1798.83 permits you to
                request a list of the third parties to which we have disclosed “personal information” (as
                that term is defined under applicable California law) for such third parties’ direct
                marketing purposes. We do not currently share personal information with third parties for
                their own direct marketing purposes.{' '}
              </p>
              <h4>
                <a name="contact" />9. HOW TO CONTACT US
              </h4>
              <p>
                If you have any questions about this Privacy Policy or the Service, please contact us at{' '}
                <a href="mailto:privacy@playvs.com">privacy@playvs.com</a> or by writing to us at PlayVS,
                1447 2<sup>nd</sup> Street Suite 200, Santa Monica, CA 90401, Attention: PlayVS Legal
                Department.{' '}
              </p>
              <h4>
                <a name="changes" />10. CHANGES TO OUR PRIVACY POLICY{' '}
              </h4>
              <p>
                PlayVS may modify or update this Privacy Policy from time to time so you should review this
                page periodically. If we change the policy in a material manner, for example if we seek to
                use personal information in a materially different way than we had previously, we will let
                you know and update the ‘last modified’ date at the bottom of this page. If you object to
                any changes, you may close your account. Continuing to use our Service after we publish
                changes to this Privacy Policy means that you are consenting to the changes.{' '}
              </p>
            </div>
          </div>
        </section>

        <Footer />

      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/ui/pages/privacy.js